import { useEffect, Component } from "react";
import { BrowserRouter } from "react-router-dom";
import Lenis from "lenis";
import "./App.css";
import { Nav } from "./components/Nav";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { Services } from "./components/Services";
import { Fleet } from "./components/Fleet";
import { Coverage } from "./components/Coverage";
import { BookingSection } from "./components/BookingSection";
import { Payments } from "./components/Payments";
import { Footer } from "./components/Footer";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  render() {
    if (this.state.err) {
      return (
        <div className="min-h-screen bg-ink text-white flex items-center justify-center font-display">
          Something went wrong — email sydneyasaptaxis@gmail.com.
        </div>
      );
    }
    return this.props.children;
  }
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, anchors: { offset: -64 } });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <div id="top" className="relative min-h-screen bg-ink text-white font-body overflow-x-clip">
          <div className="grain" aria-hidden="true" />
          <Nav />
          <main>
            <Hero />
            <Marquee />
            <Services />
            <Fleet />
            <Coverage />
            <BookingSection />
            <Payments />
          </main>
          <Footer />
        </div>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
